import React from 'react';
import ReactDOM from 'react-dom';
import LoggedInPage from '../../views/core/LoggedInPage';
import { FormGroup, Label, Input } from 'reactstrap';
import AdminLayout from './AdminLayout';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import HmAjax from '../../util/HmAjax';
import AdminModal from './AdminModal';
import CoreAjax from '../../util/CoreAjax';
import $ from 'jquery';
import HmEventRegistry from '../../model/HmEventRegistry';

export default class RegUsersTable extends LoggedInPage {

    constructor(props){
        super(props)
        this.state={
            dataLoaded:false,
            dropdownOpen: false,
            tableData: null,
            serverMessage:"",
            modalShow:false,
            data:["All","None"],
            allowtoShow:false,
            RegistrationOpen:false,
            type:"",
            nouseravailable:false,
            schoolsDataList:null
        }
        this.toggle = this.toggle.bind(this);
        this.createSelectItems = this.createSelectItems.bind(this);
        this.customDropdown = this.customDropdown.bind(this);
        this.getuserList = this.getuserList.bind(this);
        this.editCheckBox = this.editCheckBox.bind(this);
        this.editStudent = this.editStudent.bind(this);
        this.editMore = this.editMore.bind(this);
        this.revertRegistration = this.revertRegistration.bind(this);
        this.printAdmitCard = this.printAdmitCard.bind(this);
        this.removeUserData = this.removeUserData.bind(this);
        this.hideAdminModal = this.hideAdminModal.bind(this);
        this.checkAllfn = this.checkAllfn.bind(this);
        this.dropdownCheckAllfn = this.dropdownCheckAllfn.bind(this);
        this.selectAllData = this.selectAllData.bind(this);
        this.duplicateEntryAllowed = (window.contest_reg_duplicates && window.contest_reg_duplicates["allowed"]) ? window.contest_reg_duplicates["allowed"] : false;
        this.duplicateLoginIds = new Set();
        this.duplicateLoginIdAction = (window.contest_reg_duplicates && window.contest_reg_duplicates["action"]) ? window.contest_reg_duplicates["action"].toLowerCase() : null;

        this.resetPwd = this.resetPwd.bind(this);
        this.resetPwdDone = this.resetPwdDone.bind(this);
        this.generateAdmitCard = this.generateAdmitCard.bind(this);
        this.userList=[];
        this.userData=null;
        this.getCount = this.getCount.bind(this);
        this.bulkPrint = window.bulkPrintAdmitCard || true;
        this.downloadAdmitCard = this.downloadAdmitCard.bind(this);

        this.tableStatus="registered";
    }

    getCount(forceLoad){
        if(typeof this.props.getCount === "function"){
            this.props.getCount(forceLoad);
        }
    }

    resetPassword(userList){
        //console.log("Admin reverted");
        let userData = userList || {};

        let postParams = {
            "userList":[
            {
                "userId": userData.userId || ''
            }
            ]
        }

        var me = this;

        var success = function(response){
            //console.log("removeUserData ",response);
            if(response!==null){
                if(response && response.pwdResetStatus==="success"){
                    me.resetPwdDone();
                }
            } 
        } 

        var failure = function(err){

        }
        new HmAjax(this.getUrlFor("CONTEST_RESET_STUD_PASS"),postParams).mask().post(success, failure);
    }

    resetPwdDone(){
        this.showAlert(" ","Your password reset successfully completed.");
    }
    
    resetPwd(userList){
        //console.log("Admin delete ",userList);
         //this.type="delete";
         let me=this;

         var buttons = [
         {
            label: me.rb("alert.ok"),
            handler: () => { 
             me.resetPassword(userList)
         }
     },
     {
        label: me.rb("alert.cancel"),
        handler: () => { 

        }
    }
    ]
    this.showAlert(this.rb("contest.resetpwd.confirm"),this.rb("contest.resetpwd.confirm.msg"),buttons);
       //this.setState({modalshow:true})
   }

   editMore(userObj){
       
    let me=this;
        //this.type="more";
        //console.log("editMore ",userObj);
        //console.log("this.userList ",this.userList);
        let type = (userObj && userObj.value) ? (userObj.value).toLowerCase() : '';
        
        if(this.userList.length<2){
            switch(type){
                case "edit":
                me.editStudent(userObj.userdata);
                break;
                case "reset password":
                if(userObj && userObj.userdata){
                    me.resetPwd(userObj.userdata);
                }
                break;
                default:
                console.log("user not clicked that option");
            }
        }else{
            this.showAlert("Error","You must select only one user.")
        }
    }

    editCheckBox(userData){
        //if(this.state.RegistrationOpen){
            this.addUserData(userData);
        //}
        // console.log("userData ",userData);
    }

    getuserList(){
        let userListLength = (this.userList) ? (this.userList.length) : 0;
        return userListLength;
    }

    revertRegistration(){
        //console.log("Admin revert");
        //this.type="revert";
        let me=this;
        //console.log("typeof userlist",me.userList);
        if(me.state.RegistrationOpen && me.userList.length>0){
            var buttons = [
            {
                label: me.rb("alert.ok"),
                handler: () => { me.removeUserData(me.userList) }
            },
            {
                label: me.rb("alert.cancel"),
                handler: () => { }
            }
            ]

            this.showAlert(this.rb("contest.revert.users"),this.rb("contest.revert.areyousure"),buttons);
        }
        //this.setState({modalshow:true})
    }

    isValidContest(contestGrpId=null){
        if(!contestGrpId){
            contestGrpId = localStorage.getItem("contestType");
        }

        if(contestGrpId){
            return window.all_contests.includes(contestGrpId);
        }

        return false;           
    }

    getSelectedContestGroup(){
        let contestGrpParam = (this.props.match && this.props.match.params && this.props.match.params.contestGrpId) ? this.props.match.params.contestGrpId : localStorage.getItem("contestType");
        
        if(contestGrpParam  && this.isValidContest(contestGrpParam)){
            localStorage.setItem("contestType",contestGrpParam);
        }else{
            localStorage.setItem("contestType",window.default_contest);
        }

        return localStorage.getItem("contestType");
    }

    removeUserData(userList){
        //console.log("Admin reverted");
        var formObj = JSON.stringify({ "userList":Array.from(userList)||[]});

        let postParams = {
            "userList":Array.from(userList)||[]
        }
        //console.log("formObj ",typeof formObj);
        var me = this;

        var success = function(response){
            
            if(response && response.update_status==="success"){
                let existingUsers = (response.existingUsers) ? JSON.parse(response.existingUsers) : null;
                me.loadJson(JSON.parse(existingUsers));
                me.getCount(true);
            }
        } 

        var failure = function(err){

        }
        new HmAjax(this.getUrlFor("CONTEST_REV_STUD_FRM_REG").replace("{#contestId}",this.getSelectedContestGroup()),postParams).mask().post(success, failure);
    }

    generateAdmitCard(){
        let me = this;

        let userList = this.userList;
        //console.info(" lalala 1 ::", userList);
        let postParams = {};

        if(userList && userList.length > 0){
            let tempUserList = [];

            for(let i=0; i < userList.length ; i++){
                if(userList[i]){
                   let userObj = {};
                   userObj["userId"] = userList[i]["userId"] || "";
                   userObj["loginId"] = userList[i]["loginId"] || "";
                   userObj["userName"] = userList[i]["Name"] || "";
                  //userObj["prepPurchaseStatus"] = userList[i]["Prep Purchase Status"] || "";
                   userObj["email"] = userList[i]["Email"] || "";
                   
                   userObj["levelSecMap"] = {
                    "levelName": userList[i]["Level"] || "",
                    "sectionName": userList[i]["Class"] || ""
                   };
                  tempUserList.push(userObj);
                }
            }
            postParams["userList"] = tempUserList;
        }else{
            return;
        }

        let success = (response) => {
            if(response && response.filePath && (response.code === 200 || response.status === "success")){
                let filePath = response.filePath || "";
                let fileName = filePath.substr(filePath.lastIndexOf("/")+1,filePath.length);

                if(fileName){
                    me.downloadAdmitCard(fileName);
                }
            }else{
                me.showAlert("" , me.rb(response.status));
            }
        }

        let failure = (err) => {
                    //Show prompt for error
            console.error("Error occurred while trying to generateAdmitCard : ", err);
        }

          new HmAjax(this.getUrlFor("GENERATE_ADMIT_CARD").replace("{#contestId}",this.getSelectedContestGroup()), postParams).mask().post(success, failure);
    }

    downloadAdmitCard(fileName){
        window.open(this.getUrlFor("DOWNLOAD_ADMIT_CARD").replace("{#contestId}",this.getSelectedContestGroup()).replace("{#fileName}",fileName));
    }

    /**
    * This method is there as a reference. but no longer used
    */
    printAdmitCard(){

        if(this.getUrlFor("CONTEST_PRINT_ADMIT_CARD_ALL") && this.getSelectedContestGroup()){
            //window.open(this.getUrlFor("CONTEST_PRINT_ADMIT_CARD_ALL").replace("{#contestId}",this.getSelectedContestGroup()));
        }else{
            console.warn("Cannot print admit card: either URL not configured or contestId not selected");
        }
    }

    hideAdminModal(userResponse=null){
        var me=this;
        var callBack = function(){
            me.setState({type:"",modalShow:false})
        }
        if(userResponse){
            this.loadJson(userResponse,callBack);
        }else{
            callBack.apply(this);
        }
    }

    componentDidMount(){
        console.warn("Registration trackId "+this.props.RegistrationOpen)
        //alert("loadCurrentImage....");
        let RegistrationOpen = this.props.RegistrationOpen || false;
        this.loadJson();
        this.getContestLevelName();
        this.setState({RegistrationOpen:RegistrationOpen})
        //console.log("RegistrationOpen componentDidMount Reg",RegistrationOpen);
        HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
    }

    getContestLevelName(){
        let me=this;

        var callBackSuccess=function(response){
            //console.log("getContestLevelName ",response);
            if(response!==null){
                if(response.status=="success"){
                    //me.selectedSchoolOption = response.schoolsList
                    //me.setState({selectedSchoolOption:response.schoolsList})
                    if(response.levelSecInfo){
                        me.setState({schoolsDataList:response})
                        //me.populateSchoolLevelDropdown(response.levelSecInfo);
                    }
                }
            }
        }

        var callBackFailure=function(response){
            //console.log("response school failure",response);
        }

         new HmAjax(this.getUrlFor("CONTEST_TIC_LEV_AND_SEC").replace("{#contestId}",this.getContestHost())).get(callBackSuccess, callBackFailure);
        
    }

    loadJson(response = null,callBack){
        let trackId = this.props.trackId;
        var me = this;
        let selfLoaded = false;
        if(response!==null){
            selfLoaded = true;
        }
        this.userList=[];
        this.setState({dataLoaded:false});
        var success = function(response){
            if(response!==null){
                //console.log("Reg response  ",response.userList);
                    if(response && response.userList){
                    let userList =  me.filterDuplicates(response.userList) || [];
                    let tableData = me.renderJsonData(userList);
                    me.setState({tableData:tableData, dataLoaded:true,nouseravailable:false});
                }else if(response && response.status==="no_users_available"){
                    me.setState({dataLoaded:true,nouseravailable:true}); 
                }

                if(typeof callBack === "function"){
                    callBack.apply(this);
                }

                let checked = $("#checkAll").is(':checked');
                if(!(checked)){
                    $(".singleCheck input:checkbox").each(function(){
                        $(this).prop("checked",false);
                    });
                }

                if(response && response.userList){
                    me.refreshUI();
                }
            }
        } 

        var failure = function(err){

        }

        if(!selfLoaded){
            new HmAjax(this.getUrlFor("CONTEST_GET_REGIS_REG").replace("{#contestId}",this.getSelectedContestGroup())).get(success, failure);
        }else{
            success.apply(this,[response]);
        }
    }

     filterDuplicates(userList, forceFilter=false){
        let me = this;
                    
        if(!this.duplicateEntryAllowed || forceFilter){
            let uniqUserList = [];

            if(userList && userList.length > 0){
                let tempLoginSet = new Set();
                let uniqDefiners = ["userName","levelSecMap>levelName","levelSecMap>sectionName"];

                for(let i=0; i< userList.length; i++){
                    let tmpUniqKey = "";
                    try{
                        for(let k=0; k<uniqDefiners.length; k++){
                            if(uniqDefiners[k]){
                                if(~uniqDefiners[k].indexOf(">")){
                                    let tmpDefinerArr = uniqDefiners[k].split(">");
                                    if(tmpDefinerArr.length > 1){
                                     tmpUniqKey += (userList[i][tmpDefinerArr[0]] && userList[i][tmpDefinerArr[0]][tmpDefinerArr[1]]) ? userList[i][tmpDefinerArr[0]][tmpDefinerArr[1]] : "";     
                                 }else{
                                     tmpUniqKey += (userList[i][tmpDefinerArr[0]]) ? userList[i][tmpDefinerArr[0]] : "";     
                                 }
                             }else{
                                tmpUniqKey += (userList[i][uniqDefiners[k]]) ? userList[i][uniqDefiners[k]] : "";
                            }
                        }
                    }
                }catch(e){
                    console.error(e);
                }

                if(tmpUniqKey && tempLoginSet.has(tmpUniqKey.toLowerCase())){
                     let userObj = {
                        "loginId" : userList[i].loginId,
                        "userId" : userList[i].userId,
                        "userRefId" : userList[i].userRefId
                    };
                                          
                    userList[i].duplicate = true;    
                    me.duplicateLoginIds.add(userObj);                    
                }else{
                    userList[i].duplicate = false;
                    uniqUserList.push(userList[i]);
                    tempLoginSet.add(tmpUniqKey.toLowerCase());
                }
            }

            if(me.duplicateLoginIds.size > 0){
                me.deleteDuplicateLogins();
            }
            return (uniqUserList && uniqUserList.length > 0 && !this.duplicateEntryAllowed) ? uniqUserList : userList;
        }
        }
        return userList;
    }

deleteDuplicateLogins(){
    let me = this;
    if(!this.duplicateEntryAllowed &&  this.duplicateLoginIds.size > 0){
        console.warn("IRREVERSIBLE ACTION: DELETING the Duplicate Logins ::", this.duplicateLoginIds);

        if(this.duplicateLoginIdAction === "force_delete"){
            let failure = (err) => {
                console.error(err);
            }

            let success = (resp) => {
                console.warn("Success :", resp);
            }

            let postData = {
                "userList": me.duplicateLoginIds,
                "userStatus": [me.tableStatus]
            }

            new CoreAjax(this.getUrlFor("DELETE_ACCOUNTS"),postData).post(success, failure);
        }else{
            console.warn("NOT DELETING THE ACCOUNTS  Since the chosen action is not 'force_delete' ");
        }
    }
}

renderJsonData(userList){
    let me = this;
    let tableData = [];

    if(me.duplicateLoginIdAction === "highlight"){
        userList = me.filterDuplicates(userList, true);
    }

    userList.map((userData,index)=>{
        tableData[index]={}
        tableData[index]["Student Name"]=userData["userName"];
        tableData[index]["User ID"]=userData["loginId"];


        if(userData["levelSecMap"] && typeof userData["levelSecMap"] === "object"){
            tableData[index]["Level"]=userData["levelSecMap"]["levelName"];
            tableData[index]["Class"]=userData["levelSecMap"]["sectionName"];
        }        

        tableData[index]["Email ID"]=userData["email"];    
        if(userData["prepPurchaseStatus"]!==undefined){
            tableData[index]["Prep Course"]=userData["prepPurchaseStatus"];
        }

        tableData[index]["gender"]=userData["gender"];
        tableData[index]["userId"]=userData["userId"];
        tableData[index]["userRefId"]=userData["userRefId"];

        tableData[index]["checked"] = false;
        tableData[index]["duplicate"]= (me.duplicateLoginIdAction === "highlight" && userData["duplicate"]) ? userData["duplicate"] : false; 

        this.schoolName  = userData["schoolName"];
        this.startDate  = new Date(userData["testStartTime"] * 1000).toString();
        this.endDate  = new Date(userData["testEndTime"] * 1000).toString()
    })

    return tableData;
}

toggle() {
    this.setState(prevState => ({
        dropdownOpen: !prevState.dropdownOpen
    }));
}

optionClick(value,e){
        //console.log("option clicked ",value);
        //$(value).addClass("deepika");
        this.setState(prevState => ({
            tick: !prevState.tick           
        })) 
    }

    createSelectItems() {
        let tick = this.state.tick ? "done":"done";
        let tickCls = tick == "done" ? "success" : "";
       // console.log("tick ",tick);
       // console.log("tickCls ",tickCls);
       if(this.state.data!=null){
        return (<DropdownItem>
        {
            this.state.data.map((col,index)=>{

                return(
                    <div key={index} className="dd-option" onClick={this.optionClick.bind(this,col)}>
                    <i className={"material-icons "+tickCls}>{tick}</i>
                    <option value={col} onClick={this.dropdownCheckAllfn.bind(this,col)}>  {col} </option>
                    </div>
                    )
                })
            }
            </DropdownItem>
            )
            }
        }  

        onDropdownSelected(e) {
        //console.log("THE VAL", e.target.value);
        //here you will see the current selected value of the select input
    }
    duplicateItem = function (srcdata,key, value) {
        if (value == undefined)
            return false;

        for (var i in srcdata) {
            if (srcdata[i][key] == value) {
             return true;
         }
     }
     return false;
 };

 removeItem = function (srcdata,key, value) {
    if (value == undefined)
        return;
    for (var i in srcdata) {
        if (srcdata[i][key] == value) {
            srcdata.splice(i, 1);
        }
    }
};


addUserData(userdata){
    let userData = this.userDataForRegn(userdata);
   // console.log("userData",userData);
   let userRefId = userData.userRefId;
   // console.log("userRefId",userRefId);
   let arr = this.userList;
   let me=this;
   if(me.duplicateItem(me.userList,"userRefId",userRefId)){
    me.removeItem(me.userList,"userRefId",userRefId)
}else{
    me.userList.push(userData)
}
this.refreshUI();
return this.userList; 
}


refreshUI(){
    // console.log("userList ",this.userList.length," : ",this.state.tableData.length);
   if(this.userList.length>0 && !this.state.allowtoShow){
    this.setState({allowtoShow:true});
}else if(this.userList.length<=0 && this.state.allowtoShow){
    $("#checkAll").prop("checked",false);
    this.setState({allowtoShow:false});
}

if(this.state.tableData!==null && this.userList.length === this.state.tableData.length){
    $("#checkAll").prop("checked",true);
}else{
    $("#checkAll").prop("checked",false);
}
}

userDataForRegn(userData){
    let userDataList ={
        "userRefId":userData.userRefId,
        "loginId":userData["User ID"],
        "userId":userData.userId,
        "Email": userData["Email ID"],
        "Level": userData["Level"],
        "Name": userData["Student Name"],
        "Prep Purchase Status": userData["Prep Course"],
        "Class": userData["Class"],
        "gender":userData["gender"]
    }
    return userDataList;
}
selectAllData(type){
    let me=this;
    switch(type){
        case "add":
        {
            me.userList=[];
            let tableData = me.state.tableData || [];
            tableData.map((data,index)=>{
                me.addUserData(data);
            });
            break;
        }
        case "remove":
        {
            me.userList=[];
               // console.log("userList ",me.userList);
               break;
           }
           default:
            //console.log("empty")
        }
    }
    checkAllfn() {
        let me = this;
        
        $("#checkAll").change(function(){
            let checked = $(this).is(':checked');
            if(checked){
              $(".singleCheck input:checkbox").each(function(){
              $(this).prop("checked",true);
           });
              me.selectAllData("add");
          }else{
              $(".singleCheck input:checkbox").each(function(){
                $(this).prop("checked",false);
            });
              me.selectAllData("remove");
              me.setState({allowtoShow:false});
          }
          if(ReactDOM.findDOMNode(me.refs.AdminTable)){
            if(typeof me.refs.AdminTable.checkAllFn === "function"){
              me.refs.AdminTable.checkAllFn(checked);
            }				
          }
          $('#checkAll').off('change');
      });

        
    }
    dropdownCheckAllfn(val,e) {
        let selectedOpt = val;
        let me = this;
        if(selectedOpt == "All"){
            // $(".singleCheck input:checkbox").each(function(){
            //     $(this).prop("checked",true);
            // });
            $("#checkAll").prop("checked",true);
            me.selectAllData("add");
            if(ReactDOM.findDOMNode(me.refs.AdminTable)){
                if(typeof me.refs.AdminTable.checkAllFn === "function"){
                  me.refs.AdminTable.checkAllFn(true);
                }				
            }
        }else if(selectedOpt == "None"){
            // $(".singleCheck input:checkbox").each(function(){
            //     $(this).prop("checked",false);
            // });
            $("#checkAll").prop("checked",false);
            me.setState({allowtoShow:false});
            me.selectAllData("remove");
            if(ReactDOM.findDOMNode(me.refs.AdminTable)){
                if(typeof me.refs.AdminTable.checkAllFn === "function"){
                  me.refs.AdminTable.checkAllFn(false);
                }				
            }
        }
       // $('#checkAll').off('change');
   }

   customDropdown() {
    return (
        <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
        <DropdownToggle>
        <FormGroup check>                            
        <Input type="checkbox" id="checkAll" onChange={this.checkAllfn} /><Label check><i className="material-icons">arrow_drop_down</i>
        </Label>
        </FormGroup>
        </DropdownToggle>
        <DropdownMenu>
        {this.createSelectItems()}
        </DropdownMenu>
        </Dropdown>  
        );       
}

editStudent(userObj){
    if(this.state.RegistrationOpen){
        this.userData=userObj;
        this.setState({type:"edit",modalShow:true})
    }
    
}

render(){
    let me=this;
    let RegistrationOpen = this.state.RegistrationOpen;
 
    const settings = {
        userFeature:{
            "0":{
                "name":"checkbox",
                "order":"0",
                "clickEvent":this.editCheckBox,
                "active":true
            },
               /*  "1":{
                    "name":"star",
                    "order":"1",
                    "clickEvent":this.editStudent,
                    "active":RegistrationOpen
                }, */
                "2":{
                    "name":"more",
                    "order":"7",
                    "clickEvent":this.editMore,
                    "active":true,
                    "menuList":[{
                        "name":"Edit",
                        "active":RegistrationOpen
                    },
                    {
                        "name":"Reset Password",
                        "active":true
                    }
                ]
                }
            },
            userFeatureOrder:[0,7],
            filters : ["Prep Course","Level","Class"],
            data:this.state.tableData,
            contestType:this.getSelectedContestGroup(),
            pagination:true,
            pagePerPage:10,
            toolTipArr:[1,5]
        };

        if(!this.state.dataLoaded){
            return super.render()
        }else if(this.state.nouseravailable){
            return(
                <div>
                {/* {this.rb("contest.reg.usersnotavailable")} */}
                </div>
                )
       }else{ 
                return(
                <div className="RegTable regStud">            
                <div className="RegFunc">
                <div className="checkSelect main-check">
                {this.customDropdown()}
                </div>

                {/*  <div className="starSelect menuStar">
                <FormGroup check>                            
                <Input className="star" type="checkbox" /><Label check>Add Star
                </Label>
                </FormGroup>
            </div> */}

            
            {
                (()=>{
                   // console.log("print admitcard ",this.state.allowtoShow," : ",RegistrationOpen);
                    let allowtoShow = (this.state.allowtoShow) ? "active":"disabled";  // && !RegistrationOpen
                    //let allowtoShow = (this.state.allowtoShow && !RegistrationOpen) ? "active":"disabled";

                    //if(this.state.allowtoShow){
                        return(
                        <div className={"printSelect "+allowtoShow} data-ga="Print admit card" onClick={this.generateAdmitCard}>
                        <i className="material-icons">print</i>{this.rb("contest.reg.print")}
                        </div>
                        )
                        //}
                 })()
            }

            {
                (()=>{
                    let allowtoShow = (this.state.allowtoShow && RegistrationOpen) ? "active":"disabled";

                    //if(this.state.allowtoShow){
                        return(
                        <div className={"revertSelect "+allowtoShow} data-ga="Student Deregister" onClick={this.revertRegistration}>
                        <i className="material-icons">replay</i>{this.rb("contest.reg.revert")}
                        </div>
                        )
                        //}
                    })()
                }

                {/* <div className="revertSelect">
                <i class="material-icons">replay</i>Revert Registration
            </div> */}


                </div>

                {(()=>{
                    if(this.state.tableData && (this.state.tableData.length)>0){
                        return(
                        <AdminLayout ref={"AdminTable"} getuserList={this.getuserList} getCount={this.getCount} data={settings}/>
                        )
                    }
                })()}

                <AdminModal status={this.tableStatus} modalShow={this.state.modalShow} type={this.state.type} dataObj={this.state.schoolsDataList} callBackParent={this.hideAdminModal} userData={this.userData}></AdminModal>

                </div>
                )
            }
        }
    }


// WEBPACK FOOTER //
// ./src/views/registration/RegUsersTable.js